/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { paymentMethodIndex } from '../../axios/paymentMethodIndex'
import type {
	PaymentMethodIndexError,
	PaymentMethodIndexPathParams,
	PaymentMethodIndexQueryParams,
	PaymentMethodIndexResponse,
} from '../../types/PaymentMethodIndex'

export const paymentMethodIndexQueryKey = (
	organisation: PaymentMethodIndexPathParams['organisation'],
	params?: PaymentMethodIndexQueryParams,
) => [{ url: '/:organisation/payment-methods', params: { organisation } }, ...(params ? [params] : [])] as const

export type PaymentMethodIndexQueryKey = ReturnType<typeof paymentMethodIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::index */
export function paymentMethodIndexQueryOptions(
	organisation: PaymentMethodIndexPathParams['organisation'],
	params?: PaymentMethodIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		PaymentMethodIndexResponse,
		AxiosError<PaymentMethodIndexError>,
		PaymentMethodIndexResponse,
		PaymentMethodIndexQueryKey
	>({
		queryKey: paymentMethodIndexQueryKey(organisation, params),
		queryFn: ({ signal }) => paymentMethodIndex(organisation, params, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::index */
export function usePaymentMethodIndex<TSelectData = PaymentMethodIndexResponse>(
	organisation: PaymentMethodIndexPathParams['organisation'],
	params?: PaymentMethodIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					PaymentMethodIndexResponse,
					AxiosError<PaymentMethodIndexError>,
					TSelectData,
					PaymentMethodIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PaymentMethodIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...paymentMethodIndexQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PaymentMethodController.php PaymentMethodController::index */
export function usePaymentMethodIndexSuspense<TSelectData = PaymentMethodIndexResponse>(
	organisation: PaymentMethodIndexPathParams['organisation'],
	params?: PaymentMethodIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					PaymentMethodIndexResponse,
					AxiosError<PaymentMethodIndexError>,
					TSelectData,
					PaymentMethodIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PaymentMethodIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...paymentMethodIndexQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
